'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsDeficiency', ['$scope', '$stateParams', 'IPDeficiencies', '$state', '$uibModal', function ($scope, $stateParams, IPDeficiencies, $state, $uibModal) {
        $scope.deficiency = $stateParams.deficiency;
        $scope.deficiencyID = $stateParams.id;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = false;

        if ($stateParams.id != null) {
            $scope.loading = true;

            IPDeficiencies.getByID($stateParams.id).then(function (deficiency) {
                $scope.deficiency = deficiency;
                if ($scope.deficiency.required == null) {
                    $scope.deficiency.required = false;
                }
                $scope.loading = false;
            });
        }
        else {
            $scope.deficiency = {};
            $scope.deficiency.required = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            IPDeficiencies.save($scope.deficiency).then(function (deficiency) {
                $state.go('internal.inspecting.resource.deficiencies');
                $scope.saving = false;
            })
        }

        $scope.delete = function () {
            $scope.deleting = true;

            IPDeficiencies.delete($scope.deficiencyID).then(function () {
                $state.go('internal.inspecting.resource.deficiencies');
                $scope.deleting = false;
            })
        }

        $scope.openCategoryModal = function () {
            $scope.categoryRefresh = true;

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'inspections/components/deficiency-category-modal/deficiency-category-modal.html',
                controller: 'InternalInspectionDeficiencyCategoryModal',
                size: 'lg'
            });

            modalInstance.result.then(function (deficiency_category) {
                $scope.deficiency.deficiency_category_id = deficiency_category.id;
                $scope.categoryRefresh = false;
            });
        }
    }])
    ;